import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import { FaSearch } from "react-icons/fa";
import MaterialTable from "../../Components/Table/MaterialTable";
import { tableEye } from "../../common/Assets/imgs";
import { useNavigate } from "react-router-dom";
import { get, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";

const Admin = () => {
  const navigation = useNavigate();
  const pageRef = useRef(1);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [adminList, setAdminList] = useState([]);
  const [adminData, setAdminData] = useState(null);

  useEffect(() => {
    const AdminData = localStorage.getItem('admin_details');
    const parsedData = JSON.parse(AdminData);
    setAdminData(parsedData)
  }, []);

  console.log("adminData-==", adminData);

   const pageSize = 10;
   
  const columns = [

    {
      header: "S.No",
      // accessorFn: (row, index) => index + 1,
       accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
      id: "serial_no",
    },
    {
      accessorKey: "admin_code",
      header: "Admin ID",
    },
    {
      accessorKey: "name",
      header: "Admin Name",
    },
    {
      accessorKey: "role",
      header: "Role",
    },
    {
      accessorKey: "mobile",
      header: "Mobile Number",
    },
    {
      header: "Status",
      accessorKey: "status",
      Cell: ({ cell, row }) => {
        console.log('row?.original?.id', adminData?.admin_id);

        if (row?.original?.id === adminData?.admin_id) {
          return null;
        }

        return (
          <span
            className={`${cell.getValue() ? "status-active" : "status-inactive"}`}
            onClick={() => statusChanger(row?.original?.id, row?.original?.status)}
          >
            {cell.getValue() ? "Active" : "Inactive"}
          </span>
        );
      },
    },
    {
      id: "action", // ✅ important when no accessorKey
      header: "Action",
      Cell: ({ row }) => (
        <div
          onClick={() =>
            navigation("/add-admin", {
              state: { data: row.original, type: "view" },
            })
          }
        >
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      ),
    },
  ];

  const getList = async (page) => {
    try {
      setLoader(true);
      const res = await get(`${URLS.ADMIN_LIST}?page=${page}`);
      console.log("res", res);

      setAdminList(res?.data);
      setTotalCount(res?.count);
      setLoader(false);
    } catch (err) {
      console.log("err", err);
      setLoader(false);
    }
  };

  useEffect(() => {
    getList(pagination);
  }, [pagination]);

  const statusChanger = (id, currentStatus) => {
    put(`${URLS.ADMIN_STATUS}${id}/`, {
      status: currentStatus === 1 ? 0 : 1,
    })
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message);
          getList(pagination); // refresh table
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleSearch = async (value) => {
    setSearch(value);

    if (!value.trim()) {
      setPagination(1);
      getList(1); // if empty search, load full list
      return;
    }

    try {
      const res = await get(`${URLS.ADMIN_SEARCH}?search=${value}`);
      setAdminList(res?.data);
      setTotalCount(res?.count || res?.data?.length);
    } catch (err) {
      console.log("Search error:", err);
    }
  };
  console.log("pagination", pagination);

  return (
    <div>
      <Header title={"Admin"} />

      <div className="container-fluid main-container">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          {/* LEFT TITLE */}
          <h3 className="m-0 fw-bold fs-5 text-black">Admin</h3>

          {/* RIGHT SECTION */}
          <div className="d-flex align-items-center gap-3">
            {/* SEARCH BOX */}
            <div className="search-box d-flex align-items-center px-3">
              <input
                type="text"
                placeholder="Search"
                className="border-0 outline-none bg-transparent"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <div className="ms-2 searchdote">|</div>
              <FaSearch color="#7A52AB" className="ms-1" />
            </div>

            {/* ADD BUTTON */}
            <button
              onClick={() =>
                navigation("/add-admin",
                  { state: { type: "add" } })
              }
              style={{ backgroundColor: "#F98425" }}
              className="btn text-white fw-semibold px-4 py-2"
            >
              + Add Admin
            </button>
          </div>
        </div>
        <MaterialTable
          rowCount={totalCount}
          pagination={pagination}
          columns={columns}
          data={adminList || []}
          setPagination={setPagination}
          loading={loader}
        />
      </div>
    </div>
  );
};

export default Admin;
